import { queryOptions, useQuery, useSuspenseQuery } from "@tanstack/react-query"
import { fetchParentDocumentFolderById, fetchParentDocuments } from "./api"

export const parentDocumentsQueryOptions = () =>
    queryOptions({
        queryKey: ['parentDocuments'],
        queryFn: () => fetchParentDocuments(),
    })

export function useParentDocumentsQuery() {
    return useQuery(parentDocumentsQueryOptions())
}

export function useParentDocumentsSuspenseQuery() {
    return useSuspenseQuery(parentDocumentsQueryOptions())
}

export function parentDocumentFolderQueryOptions(folderId: string) {
    return queryOptions({
        queryKey: ['parentDocumentFolder', folderId],
        queryFn: () => fetchParentDocumentFolderById(folderId),
    })
}

export function useParentDocumentsFolderQuery(folderId: string) {
    return useQuery(parentDocumentFolderQueryOptions(folderId))
}

export function useParentDocumentsFolderSuspenseQuery(folderId: string) {
    return useSuspenseQuery(parentDocumentFolderQueryOptions(folderId))
}